<template>
    <q-card :style="$q.platform.is.mobile ? '' : 'min-width: 80vw; min-height: 80vh; max-height: 80vh;'">
        <q-toolbar>
            <q-toolbar-title>{{ $t('message') }}</q-toolbar-title>

            <q-btn flat round dense icon="fal fa-times" v-close-popup />
        </q-toolbar>

        <q-separator />

        <q-card-section class="q-px-xl q-pb-xl linkfix">
            <p class="text-h5 title">{{ message.title }}</p>

            <p class="text-weight-thin text-caption q-mb-xl">
                {{ $dateUtil.fDateText(message.send_date) }}
            </p>

            <span v-html="message.body"></span>
        </q-card-section>
    </q-card>
</template>

<script>
export default {
    name: 'UserMessage',

    props: ['message']
}
</script>

<style lang="scss" scoped>
.title {
	margin-bottom: 0;
}
</style>
